<div class="header-full">
  <!--MENU PARA VERSAO RESPONSIVA-->
  <div class="responsive">
    <mat-drawer-container class="example-container" autosize *ngIf="route == '/general/home' || route == '/general/inicio' ">
      <mat-drawer #drawer class="example-sidenav" mode="side">
        <div class="dados-menu">
          <div class="avatar">
            <img [src]="user.foto.url">
          </div>
          <h2>{{ user.nome }}</h2>
          <h3>{{ user.email }}</h3>
        </div>
        <ul>
          <li>
            <a class="edit" (click)="drawer.toggle();goTo('general/home')"> <i class="material-icons">home</i><span
                class="space-span">Home</span></a>
          </li>
          <li>
            <a class="edit" (click)="drawer.toggle();goTo('general/minhaConta')"> <i class="material-icons">person</i><span
                class="space-span">Minha Conta</span></a>
          </li>
          <li>
            <a class="edit" (click)="drawer.toggle();goTo('general/cartoes')"> <i class="material-icons">credit_card</i><span
                class="space-span">Cartões de Crédito</span></a>
          </li>
          <li>
            <a class="edit" (click)="drawer.toggle();goTo('general/cartoesDependentes')"> <i class="material-icons">card_membership</i><span
                class="space-span">Cartões Meep</span></a>
          </li>
          <li>
            <a class="edit" (click)="drawer.toggle();goTo('general/plan')"> <i class="material-icons">redeem</i><span
                class="space-span">Planos</span></a>
          </li>
          <li>
            <a (click)="drawer.toggle();goTo('/login')"> <i class="material-icons">keyboard_return</i><span class="space-span">Sair</span></a>
          </li>
        </ul>
      </mat-drawer>

      <div class="example-sidenav-content">
        <button type="button" mat-button (click)="drawer.toggle();">
          <div class="responsive-img-home">
            <i class="material-icons">menu</i>
            <!-- <i *ngIf="!leftIcon" class="material-icons">navigate_before</i> -->
          </div>
        </button>
      </div>

    </mat-drawer-container>
    <div *ngIf="route != '/general/home' && route != '/general/inicio' " class="back">
      <button (click)="goBack()">
        <i class="material-icons">keyboard_arrow_left</i>

      </button>
    </div>
    <div *ngIf="route != '/general/home' && route != '/general/inicio' " class="back-home">
      <button (click)="goTo('general/home')">
        <i class="material-icons">home</i>
      </button>
    </div>
  </div>


  <!--MENU PARA VERSAO DESKTOP-->
  <div class="desktop">
    <mat-drawer-container class="example-container" autosize *ngIf="route == '/general/home' || route == '/general/inicio' s">
      <mat-drawer #drawer class="example-sidenav" mode="side" opened="true">
        <div class="dados-menu">
          <div class="avatar">
            <img [src]="user.foto.url">
          </div>
          <h2>{{ user.nome }}</h2>
          <h3>{{ user.email }}</h3>
        </div>
        <ul>
          <li>
            <a class="edit" (click)="drawer.toggle();goTo('general/home')"> <i class="material-icons">home</i><span
                class="space-span">Home</span></a>
          </li>
          <li>
            <a class="edit" (click)="drawer.toggle();goTo('general/minhaConta')"> <i class="material-icons">person</i><span
                class="space-span">Minha Conta</span></a>
          </li>
          <li>
            <a class="edit" (click)="drawer.toggle();goTo('general/cartoes')"> <i class="material-icons">credit_card</i><span
                class="space-span">Cartões de Crédito</span></a>
          </li>
          <li>
            <a class="edit" (click)="drawer.toggle();goTo('general/cartoesDependentes')"> <i class="material-icons">card_membership</i><span
                class="space-span">Cartões Meep</span></a>
          </li>
          <li>
            <a class="edit" (click)="drawer.toggle();goTo('general/plan')"> <i class="material-icons">redeem</i><span
                class="space-span">Planos</span></a>
          </li>
          <li>
            <a (click)="drawer.toggle();goTo('/login')"> <i class="material-icons">keyboard_return</i><span class="space-span">Sair</span></a>
          </li>
          <li><small class="portal-version">v1.0.0</small></li>
        </ul>
      </mat-drawer>

      <div class="example-sidenav-content">
        <button type="button" mat-button (click)="drawer.toggle();">
          <div class="responsive-img-home">
            <i class="material-icons">menu</i>
            <!-- <i *ngIf="!leftIcon" class="material-icons">navigate_before</i> -->
          </div>
        </button>
      </div>
    </mat-drawer-container>
    <div *ngIf="route != '/general/home' && route != '/general/inicio' " class="back">
      <button (click)="goBack()">
        <i class="material-icons">keyboard_arrow_left</i>
      </button>
    </div>
    <div *ngIf="route != '/general/home' && route != '/general/inicio' " class="back-home">
      <button (click)="goTo('general/home')">
        <i class="material-icons">home</i>
      </button>
    </div>
  </div>
  <h2>{{ title }}</h2>
</div>



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/header/header.component.html